import React from 'react';
import { TimeSlotSelector } from '@components/Waveform/TimeSlotSelector';

type SelectSlotProps = {
  containerRef: React.RefObject<HTMLDivElement>;
  canvasRef: React.RefObject<HTMLCanvasElement>;
  height: number;
  width: number;
  claimedSlots: Set<number>;
  totalSlots: number;
  onSelectorClick: (event: React.MouseEvent<HTMLCanvasElement, MouseEvent>) => void;
  setDefaultX: () => void;
  handleMouseMove: (event: React.MouseEvent<HTMLCanvasElement, MouseEvent>) => void;
};

export function SelectSlot({
  containerRef,
  canvasRef,
  height,
  width,
  claimedSlots,
  totalSlots,
  setDefaultX,
  handleMouseMove,
  onSelectorClick,
}: SelectSlotProps) {
  return (
    <div
      className="flex h-[78px] items-center overflow-hidden rounded-md bg-neutral50"
      ref={containerRef}
    >
      <TimeSlotSelector
        canvasRef={canvasRef}
        height={height}
        width={width}
        claimedSlots={claimedSlots}
        totalSlots={totalSlots}
        setDefaultX={setDefaultX}
        handleMouseMove={handleMouseMove}
        onSelectorClick={onSelectorClick}
      />
    </div>
  );
}
